export const PURCHASE_URL =
  "https://storage.googleapis.com/marketplace-prod-7728-shop-cdn-e5e2/interview/data.json";

export const ITEMS_PER_PAGE = 5;

export const LOCALE_EN_US = "en-US";
